var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.951 4.283c.144.028.301 0 .43-.086a.523.523 0 0 0 .23-.373l.386-2.793a.559.559 0 0 0-.401-.601A11.75 11.75 0 0 0 7.374 0C3.952 0 2.291 1.633 2.291 5.013v1.475H.544c-.3 0-.544.244-.544.545v2.864c0 .315.243.559.544.559h1.747v11c0 .3.243.544.544.544h3.58c.286 0 .53-.243.53-.544v-11h2.892c.286 0 .515-.23.544-.516l.2-2.864a.549.549 0 0 0-.143-.416.511.511 0 0 0-.386-.172H6.945v-1.26c0-.945.1-1.175 1.073-1.175.559 0 1.318.1 1.933.23Z","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"viewBox":"0 0 11 22"};

module.exports = Facebook;

Facebook.default = Facebook;
